/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WorkspaceResourcesList from 'app/containers/Admin/Workspaces/WorkspaceResourcesList';

import { loadWorkspaceResources } from 'store/actions/admin/workspacesActions';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { get } from 'app/utils/lo/lo';
import { RESOURCE_TYPES, getResourceTypeConfig } from 'app/config/workspaceResourceTypesConfig';

/**
 * Unified component that loads workspace resources and displays them using WorkspaceResourcesList with lazy loading
 * All resource type configuration is centralized in workspaceResourceTypesConfig.js
 * To add a new resource type, just add it to WORKSPACE_RESOURCE_TYPES_CONFIG - no changes needed here!
 */
class WorkspaceLazyResourcesSidebar extends PureComponent {
    static propTypes = {
        details: PropTypes.object,
        resourceType: PropTypes.oneOf(RESOURCE_TYPES).isRequired,
        isLoading: PropTypes.bool,
        resources: PropTypes.array,
        totalRecords: PropTypes.number,
        startIndex: PropTypes.number,
        loadWorkspaceResources: PropTypes.func.isRequired,
    };

    @bind
    loadResources(options) {
        const { details, resourceType, loadWorkspaceResources } = this.props;
        return loadWorkspaceResources(details.id, resourceType, options);
    }

    render() {
        const { details, resources, isLoading, totalRecords, startIndex, resourceType } = this.props;
        const workspaceId = get(details, 'id', '');
        const config = getResourceTypeConfig(resourceType);

        if (!config) {
            console.error(`Unknown resource type: ${resourceType}`);
            return null;
        }

        const { title, type } = config;

        return (
            <>
                <WorkspaceResourcesList
                    title={title}
                    type={type}
                    id={workspaceId}
                    list={resources || []}
                    lazyLoad
                    totalRecords={totalRecords}
                    startIndex={startIndex}
                    loadData={this.loadResources}
                    isLoading={isLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { resourceType } = ownProps;
    const resourceState = state.admin.workspaces.lazyResources?.[resourceType];

    return {
        isLoading: resourceState?.isLoading || false,
        resources: resourceState?.data?.records || [],
        totalRecords: resourceState?.data?.count || 0,
        startIndex: resourceState?.data?.startIndex || 0,
    };
};

export default connect(
    mapStateToProps,
    {
        loadWorkspaceResources,
    }
)(WorkspaceLazyResourcesSidebar);
